import axios from 'axios';
import { ApiEndpoints } from './urls';
import { drfQueryParams } from './utils';

class AvailabilityApi {
  // ------ Availability User Cycles API ------
  static getAllUserCycles(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted);
    return axios.get(ApiEndpoints.availabilityUserCycleList, { params });
  }

  static getAllUserCycleLayers(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted);
    return axios.get(ApiEndpoints.availabilityUserCycleLayerList, { params });
  }

  static getUserCycle({ id }) {
    const url = ApiEndpoints.availabilityUserCycle.replace(':id:', id);
    return axios.get(url);
  }

  static createUserCycle(params) {
    return axios.post(ApiEndpoints.availabilityUserCycleList, params);
  }

  static updateUserCycle(params) {
    const { id } = params;
    return axios.patch(ApiEndpoints.availabilityUserCycle.replace(':id:', id), params);
  }

  static deleteUserCycle({ id }) {
    return axios.delete(ApiEndpoints.availabilityUserCycle.replace(':id:', id));
  }

  // ------ Availability Cycles API ------
  static getAllCycles(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted);
    return axios.get(ApiEndpoints.availabilityCycleList, { params });
  }

  static getCycle({ id }) {
    const url = ApiEndpoints.availabilityCycle.replace(':id:', id);
    return axios.get(url);
  }

  static createCycle(params) {
    return axios.post(ApiEndpoints.availabilityCycleList, params);
  }

  static updateCycle(params) {
    const { id } = params;
    return axios.patch(ApiEndpoints.availabilityCycle.replace(':id:', id), params);
  }

  static deleteCycle({ id }) {
    return axios.delete(ApiEndpoints.availabilityCycle.replace(':id:', id));
  }

  // ------ Availability Cycle Legs API ------
  static getAllCycleLegs(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted);
    return axios.get(ApiEndpoints.availabilityCycleLegList, { params });
  }

  static getCycleLeg({ id }) {
    return axios.get(ApiEndpoints.availabilityCycleLeg.replace(':id:', id));
  }

  static createCycleLeg(params) {
    return axios.post(ApiEndpoints.availabilityCycleLegList, params);
  }

  static updateCycleLeg(params) {
    const { id } = params;
    return axios.patch(ApiEndpoints.availabilityCycleLeg.replace(':id:', id), params);
  }

  static deleteCycleLeg({ id }) {
    return axios.delete(ApiEndpoints.availabilityCycleLeg.replace(':id:', id));
  }

  // ------ Availability Legs API ------
  static getAllLegs(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted);
    return axios.get(ApiEndpoints.availabilityLegList, { params });
  }

  static getLeg({ id }) {
    return axios.get(ApiEndpoints.availabilityLeg.replace(':id:', id));
  }

  static createLeg(params) {
    return axios.post(ApiEndpoints.availabilityLegList, params);
  }

  static updateLeg(params) {
    const { id } = params;
    return axios.patch(ApiEndpoints.availabilityLeg.replace(':id:', id), params);
  }

  static deleteLeg({ id }) {
    return axios.delete(ApiEndpoints.availabilityLeg.replace(':id:', id));
  }

  // ------ Availability Leg Types API ------
  static getAllLegTypes(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted);
    return axios.get(ApiEndpoints.availabilityLegTypeList, { params });
  }

  static getLegType({ id }) {
    return axios.get(ApiEndpoints.availabilityLegType.replace(':id:', id));
  }

  static createLegType(params) {
    return axios.post(ApiEndpoints.availabilityLegTypeList, params);
  }

  static updateLegType(params) {
    const { id } = params;
    return axios.patch(ApiEndpoints.availabilityLegType.replace(':id:', id), params);
  }

  static deleteLegType({ id }) {
    return axios.delete(ApiEndpoints.availabilityLegType.replace(':id:', id));
  }

  // ------ Availability Leave Types API ------
  static getAllAvailabilityLeaveTypes(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.availabilityLeaveTypeList, { params });
  }

  static getAvailabilityLeaveType({ id }) {
    return axios.get(ApiEndpoints.availabilityLeaveType.replace(':id:', id));
  }

  static createAvailabilityLeaveType(data) {
    return axios.post(ApiEndpoints.availabilityLeaveTypeList, data);
  }

  static updateAvailabilityLeaveType(data) {
    const { id } = data;
    return axios.patch(ApiEndpoints.availabilityLeaveType.replace(':id:', id), data);
  }

  static deleteAvailabilityLeaveType({ id }) {
    return axios.delete(ApiEndpoints.availabilityLeaveType.replace(':id:', id));
  }

  // ------ Availability Leave Status API ------
  static getAllAvailabilityLeaveStatus(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.availabilityLeaveStatusList, { params });
  }

  static getAvailabilityLeaveStatus({ id }) {
    return axios.get(ApiEndpoints.availabilityLeaveStatus.replace(':id:', id));
  }

  static createAvailabilityLeaveStatus(data) {
    return axios.post(ApiEndpoints.availabilityLeaveStatusList, data);
  }

  static updateAvailabilityLeaveStatus(data) {
    const { id } = data;
    return axios.patch(ApiEndpoints.availabilityLeaveStatus.replace(':id:', id), data);
  }

  static deleteAvailabilityLeaveStatus({ id }) {
    return axios.delete(ApiEndpoints.availabilityLeaveStatus.replace(':id:', id));
  }

  // ------ Availability Leave API ------
  static getAllAvailabilityLeave(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.availabilityLeaveList, { params });
  }

  static getAvailabilityLeave({ id }) {
    return axios.get(ApiEndpoints.availabilityLeave.replace(':id:', id));
  }

  static createAvailabilityLeave(data) {
    return axios.post(ApiEndpoints.availabilityLeaveList, data);
  }

  static updateAvailabilityLeave(data) {
    const { id } = data;
    return axios.patch(ApiEndpoints.availabilityLeave.replace(':id:', id), data);
  }

  static deleteAvailabilityLeave({ id }) {
    return axios.delete(ApiEndpoints.availabilityLeave.replace(':id:', id));
  }
}

export default AvailabilityApi;
